import * as React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom'
import { useEffect } from 'react'
import { Observer } from 'mobx-react'
import MapScreen from "../map/screens/map.screen";
export const Navigator = () => {
  useEffect(() => {
  }, [])

  return (
    <Observer>
      {() => {
        return (
          <Router>
            <Routes>
              <Route path='/' element={<MapScreen />} />
            </Routes>
          </Router>
        )
      }}
    </Observer>
  )
}
